import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from "../../envconfig";
import StatusCustomDropdown from '../common/StatusCustomDropdown';
import axios from "axios";
import { UserContext } from '../common/UserContext';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';

function CGM() {
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [formdata, setFormdata] = useState({
    CGM_CompanyGroupName: '',
    CGM_CompanyGroupCode: '',
    CGM_CompanyGroupStatus: 1,
  });
  const [errors, setErrors] = useState({
    required: {
      CGM_CompanyGroupName: '',
      CGM_CompanyGroupCode: '',
    },
    other: {
      CGM_CompanyGroupName: '',
      CGM_CompanyGroupCode: '',
    },
  });
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };
  const logAction = async (action, isError = false) => {
    console.log(`${isError ? '[ERROR] ' : ''}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Company Group Master:", action, userCode: UM_UserCode, isError }),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };

    // Validate CGM_CompanyGroupName
    if (!formdata.CGM_CompanyGroupName) {
      newErrors.required.CGM_CompanyGroupName = '*';
      newErrors.other.CGM_CompanyGroupName = '';
      valid = false;
    } else if (!/^[a-zA-Z0-9]$/.test(formdata.CGM_CompanyGroupName[0])) {
      newErrors.other.CGM_CompanyGroupName = 'The first characters must be alphanumeric';
      valid = false;
    } else if (!/^[a-zA-Z0-9.]$/.test(formdata.CGM_CompanyGroupName.slice(-1))) {
      newErrors.other.CGM_CompanyGroupName = 'The last character must be alphanumeric or a dot (.)';
      valid = false;
      logAction('validateForm():The last character must be alphanumeric or a dot (.)', true)
    } else if (!/^[a-zA-Z0-9_\- .&]+$/.test(formdata.CGM_CompanyGroupName)) {
      newErrors.other.CGM_CompanyGroupName = 'Please use only special characters like -, _, ., & and space';
      valid = false;
    } else if (/([_\-.&]{2,})| {2,}/.test(formdata.CGM_CompanyGroupName)) {
      newErrors.other.CGM_CompanyGroupName = 'Consecutive special characters are not allowed';
      valid = false;
    } else if (formdata.CGM_CompanyGroupName.length > 45) {
      newErrors.other.CGM_CompanyGroupName = 'Maximum length is 45 characters';
      valid = false;
    } else {
      newErrors.required.CGM_CompanyGroupName = '';
      newErrors.other.CGM_CompanyGroupName = '';
    }

    // Validate CGM_CompanyGroupCode
    if (!formdata.CGM_CompanyGroupCode) {
      newErrors.required.CGM_CompanyGroupCode = '*';
      newErrors.other.CGM_CompanyGroupCode = '';
      valid = false;
    } else if (!/^[a-zA-Z0-9]$/.test(formdata.CGM_CompanyGroupCode[0]) || !/^[a-zA-Z0-9]$/.test(formdata.CGM_CompanyGroupCode.slice(-1))) {
      newErrors.other.CGM_CompanyGroupCode = 'The first and last characters must be alphanumeric';
      valid = false;
    } else if (!/^[a-zA-Z0-9_\- ]+$/.test(formdata.CGM_CompanyGroupCode)) {
      newErrors.other.CGM_CompanyGroupCode = 'Please use only special characters like -, _ and space';
      valid = false;
    } else if (/([_\-]{2,})| {2,}/.test(formdata.CGM_CompanyGroupCode)) {
      newErrors.other.CGM_CompanyGroupCode = 'Consecutive special characters are not allowed';
      valid = false;
    } else if (formdata.CGM_CompanyGroupCode.length > 45) {
      newErrors.other.CGM_CompanyGroupCode = 'Maximum length is 45 characters';
      valid = false;
    } else {
      newErrors.required.CGM_CompanyGroupCode = '';
      newErrors.other.CGM_CompanyGroupCode = '';
    }

    setErrors(newErrors);
    return valid;
  };
const handleBlur = (e) => {
  const { name, value } = e.target;

  setFormdata((prevData) => ({
    ...prevData,
    [name]: value.trimEnd(), // 🔥 only remove trailing space
  }));
};
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Run validation for required fields and other specific fields
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };

    // Validate CGM_CompanyGroupName
    if (name === 'CGM_CompanyGroupName') {
      if (!value) {
        // newErrors.required.CGM_CompanyGroupName = '*';
        newErrors.other.CGM_CompanyGroupName = '';
        valid = false;
      } else if (!/^[a-zA-Z0-9]$/.test(value[0])) {
        newErrors.other.CGM_CompanyGroupName = 'The first characters must be alphanumeric';
        valid = false;
        logAction('handleInput():The first characters must be alphanumeric', true)
      } else if (!/^[a-zA-Z0-9. ]$/.test(value[value.length - 1])) {
        newErrors.other.CGM_CompanyGroupName = 'The last character must be alphanumeric or a dot (.)';
        valid = false;
        logAction('validateForm():The last character must be alphanumeric or a dot (.)', true)
      } else if (!/^[a-zA-Z0-9_\- .&]+$/.test(value)) {
        newErrors.other.CGM_CompanyGroupName = 'Please use only special characters like -, _, ., & and space';
        valid = false;
        logAction('handleInput():Please use only special characters like -, _, . and space', true)
      // } else if (/([_\-.&]{2,})|{2,}/.test(value)) {
      } else if (/([_\-.&]{2,})/.test(value) || / {2,}(?=\S)/.test(value)) {
        newErrors.other.CGM_CompanyGroupName = 'Consecutive special characters are not allowed';
        valid = false;
        logAction('handleInput():Consecutive special characters are not allowed', true)
      } else if (value.length > 45) {
        newErrors.other.CGM_CompanyGroupName = 'Maximum length is 45 characters';
        valid = false;
      } else {
        newErrors.required.CGM_CompanyGroupName = '';
        newErrors.other.CGM_CompanyGroupName = '';
      }
    }

    // Validate CGM_CompanyGroupCode
    if (name === 'CGM_CompanyGroupCode') {
      if (!value) {
        // newErrors.required.CGM_CompanyGroupCode = '*';
        newErrors.other.CGM_CompanyGroupCode = '';
        valid = false;
      } else if (!/^[a-zA-Z0-9]$/.test(value[0]) || !/^[a-zA-Z0-9 ]$/.test(value[value.length - 1])) {
        newErrors.other.CGM_CompanyGroupCode = 'The first and last characters must be alphanumeric';
        valid = false;
        logAction('handleInput():The first and last characters must be alphanumeric', true)
      } else if (!/^[a-zA-Z0-9_\- ]+$/.test(value)) {
        newErrors.other.CGM_CompanyGroupCode = 'Please use only special characters like -, _ and space';
        valid = false;
        logAction('handleInput():Please use only special characters like -, _ and space', true)
      } else if (/([_\-]{2,})/.test(value) || / {2,}(?=\S)/.test(value)) {
        newErrors.other.CGM_CompanyGroupCode = 'Consecutive special characters are not allowed';
        valid = false;
        logAction('handleInput():Consecutive special characters are not allowed', true)
      } else if (value.length > 45) {
        newErrors.other.CGM_CompanyGroupCode = 'Maximum length is 45 characters';
        valid = false;
      } else {
        newErrors.required.CGM_CompanyGroupCode = '';
        newErrors.other.CGM_CompanyGroupCode = '';
      }
    }

    setErrors(newErrors);
    // If validation fails, do not proceed with form submission
    if (!valid) {
      return;
    }
    setFormdata({ ...formdata, [name]: value });
    setMessage('');

  };

  // Audit Trail
  const audittransection = async (data) => {
    const formData = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTR_NewValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName
    };
    try {
      const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
      // alert('Data inserted successfully');
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error('Server responded with an error:', error.response.data);
        // alert(`Error: ${error.response.status} - ${error.response.data}`);
      } else if (error.request) {
        // No response received from server
        console.error('No response received:', error.request);
        // alert('Error: No response received from server');
      } else {
        // Other errors
        console.error('Error setting up the request:', error.message);
        // alert('Error: Request setup failed');
      }
    }
  }
  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    if (UM_CompanyID === null || UM_CompanyID === "null" || UM_CompanyGrpID === null || UM_CompanyGrpID === "null" || selectedScpId === null || selectedScpId === "null") {
      console.log("null--------")
      const data = {
        AUTR_ScreenName: "Company Group Master",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: null,
        AUTR_CompanyGrpId: null,
        AUTR_CompanyID: null,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp
      };
      console.log(data)
      try {
        const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
        console.log('Success:', response.data);
        return response.data;
      } catch (error) {
        console.error('Error:', error);
      }
    } else {
      console.log("null--------")
      const data = {
        AUTR_ScreenName: "Company Group Master",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: selectedScpId,
        AUTR_CompanyGrpId: UM_CompanyID,
        AUTR_CompanyID: UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp
      };
      console.log(data)
      try {
        const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
        console.log('Success:', response.data);
        return response.data;
      } catch (error) {
        console.error('Error:', error);
      }
    }

  };

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);

    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Clear any existing toasts
    // toast.dismiss();
    if (!validateForm()) {
      return;
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formdata,
        // CGM_CompanyGroupName: formdata.CGM_CompanyGroupName.trim(),
        // CGM_CompanyGroupCode: formdata.CGM_CompanyGroupCode.trim(),
        CGM_ID: null, // Ensure CGM_ID is null for insertion
        CGM_CreatedBy: UM_UserId,
        CGM_ModifiedBy: UM_UserId,
      }),
    };

    try {
      setIsLoading(true);
      const response = await fetch(`${config.API_URL}/CGM`, requestOptions);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to insert data');
      }

      logAction(`Company Group : ${formdata.CGM_CompanyGroupName} saved successfully`);

      const details = {
        AUTR_Message: `${formdata.CGM_CompanyGroupName} saved successfully`,
        AUTR_AuditType: "insert",
        AUTRN_NewValue: formdata.CGM_CompanyGroupName
      };
      let id = await (audittrailpost(details));
      const cgname = {
        AUTRN_ParamererName: "Company Group Name",
        AUTRN_NewValue: formdata.CGM_CompanyGroupName,
        AUTRN_ID: id
      }

      const status = {
        AUTRN_ParamererName: "Company Group Status",
        AUTRN_NewValue: formdata.CGM_CompanyGroupStatus === 1 ? 'Active' :
          formdata.CGM_CompanyGroupStatus === 2 ? 'Inactive' : 'Unknown',
        AUTRN_ID: id
      };

      const cgcode = {
        AUTRN_ParamererName: "Company Group Code",
        AUTRN_NewValue: formdata.CGM_CompanyGroupCode,
        AUTRN_ID: id
      }
      audittransection(cgname)
      audittransection(status)
      audittransection(cgcode)
      showToast('success', `Company Group : ${formdata.CGM_CompanyGroupName} saved successfully.`, {
        onClose: () => {
          // Clear form data after successful submission
          setFormdata({
            CGM_CompanyGroupName: '',
            CGM_CompanyGroupCode: '',
            CGM_CompanyGroupStatus: 1,
          });
          setIsLoading(false); // ✅ Enable AFTER toast ends
        }
      });

    } catch (error) {
      setIsLoading(false); // ✅ Enable AFTER toast ends
      // Handle errors, including duplicate entry cases
      console.error('Error inserting data:', error.message);
      if (error.message.includes('Both Company Group Code and Name')) {
        showToast('error', `Company Group Name : ${formdata.CGM_CompanyGroupName} and Company Group Code : ${formdata.CGM_CompanyGroupCode} already exist.`)
      } else if (error.message.includes('Company Group Code')) {
        showToast('error', `Company Group Code : ${formdata.CGM_CompanyGroupCode} already exists.`)
      } else if (error.message.includes('Company Group Name')) {
        showToast('error', `Company Group Name : ${formdata.CGM_CompanyGroupName} already exists.`)
      } else {
        showToast('error', `Company Group : ${formdata.CGM_CompanyGroupName} could not be saved successfully`);
        logAction('Error inserting data.', true);
      }
      logAction('Error inserting data.', true);
    }
  };
  const handleCancel = () => {
    // Reset the form data
    setFormdata({
      CGM_CompanyGroupName: '',
      CGM_CompanyGroupCode: '',
      CGM_CompanyGroupStatus: 1,
    });

    // Clear any existing messages and errors
    setMessage('');
    setErrors({
      required: {
        CGM_CompanyGroupName: '',
        CGM_CompanyGroupCode: '',
      },
      other: {
        CGM_CompanyGroupName: '',
        CGM_CompanyGroupCode: '',
      },
      duplicateMsg: '',
    });

    logAction("Clear all fields data.");
  };
  const handleSelectChange = (name, selectedOption) => {
    setFormdata(prev => ({
      ...prev,
      [name]: selectedOption?.value ?? null,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
    // logAction(`Select opened: ${selectName}`);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
    // logAction("Select closed");
  };
  return (
    <React.Fragment>
      <ToastContainer style={{ marginTop: '73px', fontSize: '14px', width: '40%' }} />
      {isLoading && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height

          zIndex: 1000 // Sit on top of the other elements
        }} />
      )}
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className='main_container'>
          <h3 className="formHeading">
            Company Group Master
          </h3>

          <div className='your-form-containe row'>
            {/* <div className='form-section'> */}
            <div className="col-md-6">
              <label>Company Group Name<span className="text-danger  ">{errors.required.CGM_CompanyGroupName}</span> </label>
              <input
                type="text"
                name="CGM_CompanyGroupName"
                className='form-input'
                value={formdata.CGM_CompanyGroupName}
                onChange={handleInput}
                maxLength={45}
                onBlur={handleBlur}
              />
              <div className="text-danger">{errors.other.CGM_CompanyGroupName}</div>
            </div>

            <div className="col-md-6">
              <label>Company Group Code <span className="text-danger  ">{errors.required.CGM_CompanyGroupCode}</span> </label>
              <input
                type="text"
                name="CGM_CompanyGroupCode"
                className='form-input'
                value={formdata.CGM_CompanyGroupCode}
                onChange={handleInput}
                maxLength={45}
                onBlur={handleBlur}
              />
              <div className="text-danger ">{errors.other.CGM_CompanyGroupCode}</div>
            </div>

            <div className="col-md-6">
              <label>Company Group Status  <span className='text-danger  '>{errors.CGM_CompanyGroupStatus}</span></label>
              <div className='select-container'>
                {/* <StatusCustomDropdown
                    name='CGM_CompanyGroupStatus'
                    options={[
                      { value: 1, label: 'Active' },
                      { value: 2, label: 'Inactive' },
                    ]}
                    value={formdata.CGM_CompanyGroupStatus || 1} // Assuming '1' is the value for Active
                    onChange={handleInput}
                    idKey='value'
                    displayKey='label'
                    onMenuOpen={() => handleSelectOpen('CGM_CompanyGroupStatus')}
                    onMenuClose={handleSelectClose}
                  /> */}
                <Select
                  name="CGM_CompanyGroupStatus"
                  options={[
                    { value: 1, label: 'Active' },
                    { value: 2, label: 'Inactive' },
                  ]}
                  value={[
                    { value: 1, label: 'Active' },
                    { value: 2, label: 'Inactive' },
                  ].find(opt => opt.value === formdata.CGM_CompanyGroupStatus)}
                  onChange={(selectedOption) =>
                    handleSelectChange('CGM_CompanyGroupStatus', selectedOption)
                  }
                  onMenuOpen={() => handleSelectOpen('CGM_CompanyGroupStatus')}
                  onMenuClose={handleSelectClose}
                  classNamePrefix="react-select"
                  isSearchable={false}
                />
                <div className="icon-container_list myList">
                  {isSelectOpen === "CGM_CompanyGroupStatus" ? (
                    <IoCaretUpOutline />
                  ) : (
                    <IoCaretDownOutline />
                  )}
                </div>
              </div>
            </div>
            {/* </div> */}
            <div>
              <p className='text-success'>{message}</p>
              <p className='text-danger'>{errors.duplicateMsg}</p>
            </div>
          </div>
        </div>
        <div className="button-container">
          <button
            className="save_btn"
            type="submit"
          >SAVE</button>
          <button
            className="reset_btn"
            type="button"
            onClick={handleCancel}
          >
            RESET
          </button>
          <Link to={`/cgmlist/`} className='list_btn' type='button'> LIST </Link>
        </div>
      </form>
    </React.Fragment>
  );
}

export default CGM;

